app.service('localeService', ['$translate', '$rootScope', 'LOCALES', 'tmhDynamicLocale', 'i18nService', 'userPrefService', '$state', '$stateParams', function ($translate, $rootScope, LOCALES, tmhDynamicLocale, i18nService, userPrefService, $state, $stateParams) {
	var currentLocale; // variable pour connaitre la locale en cours
	var userLocaleGot; // boolean pour savoir si on a déjà récup la locale de l'utilisateur pour ne pas appeler la route à chaque fois

	var service = {
		/**
		 * Change la locale des differents services de tradction de l'application
		 * @param  locale
		 * @param {boolean} update mise en jour dans user_preference
		 * @return void
		 */
		set: function(locale, update) {
			if(locale) {
				$translate.use(locale);         // Change la locale de angular-translate
				tmhDynamicLocale.set(locale);   // Change la locale de angular (core)
				i18nService.setCurrentLang(service.all()[locale].short_locale);   // change la locale de UI-GRID
				if(currentLocale != locale) $rootScope.$broadcast('localeUpdate', locale);
				currentLocale = locale;

				if(update) {
					// Sauvegarde la  locale dans les preferences utilisateur dans la bdd
					userPrefService.set('interface', 'locale', locale);
					$state.transitionTo($state.current, $stateParams, {reload: true, inherit: false});
				}
			}
		},
		/**
		 * Change la locale par la locale sauvegardée en session ou par celle par defaut
		 */
		setDefault: function() {
			var storageLocale = $translate.storage().get($translate.storageKey());
			if(storageLocale) service.set($translate.storage().get($translate.storageKey()), false);
			else service.set($translate.preferredLanguage(), false);
		},
		/**
		 * Récupere la locale en cours sous forme d'objet
		 * @return {[type]} [description]
		 */
		get: function() {
			return {
				locale: currentLocale,
				country: service.all()[currentLocale].country,
				language: service.all()[currentLocale].language
			};
		},
		/**
		 * Récupere les locales dispo pour l'application (fr-fr, es-es, en-us)
		 * @return {[type]} [description]
		 */
		all: function() {
			return LOCALES.locales;
		},
		/**
		 * Load
		 * @param  {boolean} getForUser récupération de la locale en bdd ou non (si l'user est loged ou non)
		 */
		load: function(getForUser) {
			if(getForUser && !userLocaleGot) {
				// S'il est demandé de récupérer la locale pour l'user et que celle-ci n'a jamais était récupérée
				userPrefService.get('interface', 'locale').then(function(response) {
					if(angular.isDefined(response) && response) {
						service.set(response, false);
						userLocaleGot = true;
					}
				});
			}
			else if(!currentLocale) service.setDefault(); // Sinon, si il n'y à pas encore de locale pour l'app récupérée
		}
	};

	// Init
	service.load(false);
	return service;
}]);
